import IconButton from '@mui/material/IconButton'
import { reExportedColors, ITooltip } from '../../index'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { GlobalContext } from '../../../../services/context/DataContext'
import SettingIcon from '../../Icons/js/Setting'

const MapSettingButton = ({ className }) => {
  const { activeTabData } = useContext(GlobalContext)
  const [, setActiveTab] = activeTabData
  const navigate = useNavigate()

  const sendToMapConfiguration = () => {
    navigate('/adminDashboard')
    setActiveTab('83')
  }

  return (
    <div className={className}>
      <ITooltip placement='left' content='Map Configuration'>
        <IconButton
          className={className}
          onClick={sendToMapConfiguration}
          sx={(theme) => ({
            background: reExportedColors.WHITE,
            border: `2px solid ${reExportedColors.WHITE}`,
            borderRadius: 3,
            height: 40,
            padding: '7px',
            width: 40,
            '&:hover': {
              background: theme.palette.quaternary.main,
              border: `2px solid ${theme.palette.secondary.accent}`,
              '& .iconColor': {
                fill: theme.palette.primary.accent,
                transition: 'fill .25s'
              }
            }
          })}
        >
          <SettingIcon className='iconColor' />
        </IconButton>
      </ITooltip>
    </div>
  )
}

export default MapSettingButton
